import type { SortDescriptor } from "react-aria-components";

export function toAriaSortDirection(dir: string | null): "ascending" | "descending" {
  return dir === "desc" ? "descending" : "ascending";
}

export function toSortDescriptor(sort: string | null, dir: string | null): SortDescriptor | undefined {
  if (!sort) return undefined;
  return { column: sort, direction: toAriaSortDirection(dir) };
}
